/**
 * POS Retail L3-S1 — affichage stock caisse (lecture seule, non contractuelle au paiement).
 */

/** @typedef {{ managed?: boolean, status?: string, label?: string, available?: number }} PosStockDisplay */

/**
 * @param {PosStockDisplay|null|undefined} display
 * @returns {boolean}
 */
export function isPosStockDisplayManaged(display) {
  return Boolean(display?.managed && display?.label);
}

/**
 * @param {PosStockDisplay|null|undefined} display
 * @returns {{ text: string, className: string, prominent: boolean }|null}
 */
export function resolvePosStockUi(display) {
  if (!isPosStockDisplayManaged(display)) return null;
  const text = display.label;
  if (display.status === 'out') {
    return {
      text,
      className: 'text-red-700 font-semibold',
      prominent: true,
      badgeClass: 'bg-red-600 text-white',
    };
  }
  if (display.status === 'low') {
    return {
      text,
      className: 'text-amber-800 font-semibold',
      prominent: true,
      badgeClass: 'bg-amber-500 text-white',
    };
  }
  return {
    text,
    className: 'text-slate-500 font-medium',
    prominent: false,
    badgeClass: 'bg-slate-700/85 text-white',
  };
}

export const POS_STOCK_INFORMATIONAL_HINT =
  'Indication à l’instant T — la disponibilité peut changer avant l’encaissement.';
